import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// import { useGroupChannelContext } from '@sendbird/uikit-react/GroupChannel/context';

import SubNavbar from '../components/SubNavbar';
import ActiveChannelUser from './components/ActiveChannelUser';
import ActionButton from '../../ActionButton';
import { ReactComponent as EmailIcon } from '../../../assetsNew/icons/email.svg';
import { getCreatorDetailsSendbirdRequest } from '../../../sagas/creatorObject/creatorDetails/actions';
import { getRouteName } from '../../../utils/routesNames';
import useOpenBatchMessageComposer from '../../../hooks/useOpenBatchMessageComposer';

import './_chatNav.scss';
import { generateQueryFromString } from '../../../utils/queryString';

const ChatNav = () => {
  const dispatch = useDispatch();
  const { pathname, search } = useLocation();
  const [activeUser, setActiveUser] = useState({ uuid: '', name: '' });
  const [channelUrl, setChannelUrl] = useState(null);
  const [isLoadingTemplate, setIsLoadingTemplate] = useState(false);
  // The SendbirdProvider is not rendered until the token is ready, e.g. right after opening /chat directly
  const isSendbirdReady = useSelector(s => s.getSendbirdToken?.isReady) || false;

  useEffect(() => {
    const query = generateQueryFromString(search);

    if (query && query.channel) {
      setChannelUrl(query.channel);
    } else {
      setChannelUrl(null);
    }
  }, [search]); // eslint-disable-line

  const openBatchMessageComposerGuarded = useOpenBatchMessageComposer();

  const openBatchMessagePopup = () => {
    if (!openBatchMessageComposerGuarded()) return;
    setIsLoadingTemplate(true);
    dispatch(getCreatorDetailsSendbirdRequest({
      id: activeUser.uuid,
      onSuccess: data => {
        setIsLoadingTemplate(false);
        data.uuid && openBatchMessageComposerGuarded({ users: [{ uuid: data.uuid, name: data.name }], name: data.name });
      },
      onError: () => {
        setIsLoadingTemplate(false);
      }
    }));
  };

  return (
    <div className="chatNav">
      {isSendbirdReady && <ActiveChannelUser channelUrl={channelUrl} onChange={setActiveUser} />}
      <SubNavbar route={getRouteName(pathname)}>
        {activeUser.uuid && <ActionButton variant="secondary" title="Quick Templates" startIcon={<EmailIcon/>} onClick={openBatchMessagePopup} loading={isLoadingTemplate}/>}
      </SubNavbar>
    </div>
  );
};

export default ChatNav;